/**
 * Created by Administrador on 25/04/2019.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('classAvailabilityService',classAvailabilityService);

    classAvailabilityService.$inject = ['$http', 'CONFIG','messageService'];

    function classAvailabilityService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/report-class-availability';

        var service = {
            getClassAvailabilityByFlight: getClassAvailabilityByFlight,
            getClassAvailabilityByConnection: getClassAvailabilityByConnection
        };

        return service;

        function getClassAvailabilityByFlight(fromDate, toDate){
            return $http.get(urlBase + '/flight' + '?fromDate='+fromDate + '&toDate=' + toDate )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getClassAvailabilityByConnection(fromDate, toDate){
            return $http.get(urlBase + '/connection' + '?fromDate='+fromDate + '&toDate=' + toDate )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }
    }
})();
